import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginexistComponent } from './pre-login/loginexist/loginexist.component';
import { SharedModule } from './modules/shared.module';


const routes: Routes = [



  //-----------------------------------------------
  {
    path: '',
    //component: PreLoginComponent
    loadChildren: () => import('./modules/prelogin.module').then((m) => m.PreloginModule)
  },
  {
    path: 'returnurl',
    //component: PreLoginComponent
    loadChildren: () => import('./modules/prelogin.module').then((m) => m.PreloginModule)
  },
  {
    path: 'pre-login',
    loadChildren: () => import('./modules/prelogin.module').then((m) => m.PreloginModule)
  },
  {
    path: 'otp-verification',
    loadChildren: () => import('./modules/otp-verification-component.module').then((m) => m.OtpVerificationComponentModule)
  },
  {
    path: 'enter-pin',
    loadChildren: () => import('./modules/enter-pin-component.module').then((m) => m.EnterPinComponentModule)
  },
  {
    path: 'setup-pin',
    loadChildren: () => import('./modules/setup-pin-component.module').then((m) => m.SetupPinComponentModule)
  },
  {
    path: 'user-not-registered',
    loadChildren: () => import('./modules/login-for-not-register-user-component.module').then((m) => m.LoginForNotRegisterUserComponentModule)
  },
  {
    path: 'totp-verification',
    loadChildren: () => import('./modules/totp.module').then((m) => m.TotpModule)
  },
  {
    path: 'login-exist', component: LoginexistComponent
  },
  {
    path: 'vlogin-page',
    //component: PreLoginComponent
    loadChildren: () => import('./modules/prelogin.module').then((m) => m.PreloginModule)
  },
  {
    path: 'Home/ClientCookieAuth',
    //component: PreLoginComponent
    loadChildren: () => import('./modules/prelogin.module').then((m) => m.PreloginModule)
  },
  {
    path: 'ClientCookieAuth',
    //component: PreLoginComponent
    loadChildren: () => import('./modules/prelogin.module').then((m) => m.PreloginModule)
  },
  {
    path: '**',
    loadChildren: () => import('./modules/prelogin.module').then((m) => m.PreloginModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [SharedModule, RouterModule]
})
export class AppRoutingModule {
  constructor() {
    console.log('AppRoutingModule loaded');
    let patterns = [
      '/SignOn/Auth',
      '/login-customersupport',
      '/error',
      '/lwp',
      '/dealer',
      '/Home/ClientCookieAuth',
      '/clientcookieauth'
    ];
  }
}